import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import SubscriptionPage from './routes/SubscriptionPage'
import SubscriptionPage2 from './routes/SubscriptionPage2'
import SubscriptionPage3 from './routes/SubscriptionPage3'

const App = () => {
  const router=createBrowserRouter([
    {
      path:"/",
      element:<SubscriptionPage2 />
    },
  ])
  return (
    <RouterProvider router={router} />
  )
}

export default App